import type { PayrollProvider } from '@omnipresentgroup/types';

export const DEFAULT_PAYROLL_PROVIDER: PayrollProvider = {
  id: 'payroll-provider-id-01',
  lspId: 'LSP-21-001',
  countryCode: 'GB',
  name: 'Mock Payroll Provider',
  hasHistory: false,
  isActive: true,
  createdAt: '2023-07-19T14:33:48.878Z',
  updatedAt: '2023-07-20T14:39:48.878Z',
  contactEmails: 'test-email@test.com',
  profileUrl: 'https://www.test.com',
};

export const INACTIVE_PAYROLL_PROVIDER: PayrollProvider = {
  ...DEFAULT_PAYROLL_PROVIDER,
  id: 'payroll-provider-id-02',
  name: 'Inactive Payroll Provider',
  isActive: false,
  countryCode: 'ES',
};

export const GET_PAYROLL_PROVIDERS_RESPONSE = [
  DEFAULT_PAYROLL_PROVIDER,
  INACTIVE_PAYROLL_PROVIDER,
];
